import { z } from 'zod';

export const ModelSizeHintSchema = z.object({
  id: z.string().optional(),
  value: z.string().min(1, 'Value is required'),
  measure: z.string(),
  sortOrder: z.coerce
    .number({ invalid_type_error: 'Order must be a number' })
    .int('Order must be an integer')
    .min(0, 'Order must be 0 or greater'),
});

export const ModelSizeFormSchema = z.object({
  value: z.string().min(1, 'Size name is required'),
  sortOrder: z.coerce
    .number({ invalid_type_error: 'Order must be a number' })
    .int('Order must be an integer')
    .min(0, 'Order must be 0 or greater'),
  hints: z.array(ModelSizeHintSchema),
});

export type ModelSizeFormValues = z.infer<typeof ModelSizeFormSchema>;
export type ModelSizeHintFormValues = z.infer<typeof ModelSizeHintSchema>;
